(function () {
  function handleCopyLinks() {
    var copyButtons = document.querySelectorAll(".js-copy-article-link");
    if (!copyButtons.length) return;

    copyButtons.forEach(function (button) {
      var labelNode = null;
      var originalLabel = "";

      for (var i = button.childNodes.length - 1; i >= 0; i -= 1) {
        var node = button.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          labelNode = node;
          originalLabel = node.textContent;
          break;
        }
      }

      var originalAriaLabel = button.getAttribute("aria-label") || "";

      button.addEventListener("click", function () {
        var value = button.getAttribute("data-url");
        if (!value) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value);
        } else {
          var input = document.createElement("input");
          input.value = value;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }

        if (labelNode) {
          labelNode.textContent = originalLabel.replace(/Copy link/i, "Copied");
        }
        button.setAttribute("aria-label", "Copied");
        window.setTimeout(function () {
          if (labelNode) {
            labelNode.textContent = originalLabel;
          }
          if (originalAriaLabel) {
            button.setAttribute("aria-label", originalAriaLabel);
          }
        }, 1200);
      });
    });
  }

  function trackSidebarScrollState() {
    var lists = document.querySelectorAll(".js-luah-product-list");
    if (!lists.length) return;

    lists.forEach(function (list) {
      if (list.scrollHeight <= list.clientHeight) return;

      list.addEventListener("scroll", function () {
        if (list.scrollTop > 6) {
          list.classList.add("is-scrolling");
        } else {
          list.classList.remove("is-scrolling");
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      handleCopyLinks();
      trackSidebarScrollState();
    });
  } else {
    handleCopyLinks();
    trackSidebarScrollState();
  }
})();
